module.exports = __webpack_public_path__ + "static/media/35.99f63c05.png";